// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__QrYW2","list":"style_list__P+hFg"};